import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { getWhatsAppUrl } from '../utils/whatsapp';
export const FloatingWhatsApp = () => {
  const {
    t
  } = useLanguage();
  const handleClick = () => {
    const message = t('wa.help');
    window.open(getWhatsAppUrl(message), '_blank');
  };
  return <div className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 group" style={{
    marginBottom: 'env(safe-area-inset-bottom, 0px)'
  }} data-id="element-174" data-mp="3ok592ikcuwuw">
      {/* Pulsing rings */}
      <motion.span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366]" animate={{
      scale: [1, 1.6],
      opacity: [0.5, 0]
    }} transition={{
      duration: 1.8,
      repeat: Infinity,
      ease: 'easeOut'
    }} data-id="element-175" data-mp="3etal99rgnp7c" />
      <motion.span aria-hidden className="absolute inset-0 rounded-full bg-[#25D366]" animate={{
      scale: [1, 1.6],
      opacity: [0.4, 0]
    }} transition={{
      duration: 1.8,
      repeat: Infinity,
      ease: 'easeOut',
      delay: 0.9
    }} data-id="element-176" data-mp="30tsrefzb5lr4" />

      {/* Sparkle / shimmer overlay */}
      <motion.span aria-hidden className="absolute -top-1 -left-1 w-3 h-3 rounded-full bg-white" animate={{
      opacity: [0, 1, 0],
      scale: [0.6, 1.4, 0.6]
    }} transition={{
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-177" data-mp="3jgt1jargzyn9" />
      <motion.span aria-hidden className="absolute -bottom-1 -right-1 w-2.5 h-2.5 rounded-full bg-white" animate={{
      opacity: [0, 1, 0],
      scale: [0.5, 1.3, 0.5]
    }} transition={{
      duration: 2.4,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.6
    }} data-id="element-178" data-mp="214cyzyvr8ae" />

      <motion.button onClick={handleClick} className="relative bg-[#25D366] hover:bg-[#128C7E] text-white p-4 rounded-full shadow-2xl shadow-[#25D366]/50 flex items-center justify-center" aria-label="Contact on WhatsApp" animate={{
      boxShadow: ['0 0 0 0 rgba(37,211,102,0.7)', '0 0 0 18px rgba(37,211,102,0)', '0 0 0 0 rgba(37,211,102,0)']
    }} transition={{
      duration: 2.2,
      repeat: Infinity,
      ease: 'easeOut'
    }} whileHover={{
      scale: 1.1,
      rotate: -6
    }} data-id="element-179" data-mp="2rnaioey63mjv">
        <MessageCircle className="w-8 h-8" data-id="element-180" data-mp="4lsm4ts4wnb0" />
      </motion.button>

      {/* Tooltip */}
      <span className="absolute right-full top-1/2 -translate-y-1/2 mr-4 bg-white text-navy px-4 py-2 rounded-lg shadow-lg text-sm font-bold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-181" data-mp="jxmdtpuqhzc">
        {t('header.reserve')}
      </span>
    </div>;
};